<template>
  <div class="ta-lot-list-item">
    <div class="ta-lot-list-item-inner">
      <div class="ta-lot-list-item-thumb">
        <b-skeleton-img no-aspect width="240px" height="180px"></b-skeleton-img>
      </div>
      <div class="ta-lot-list-item-desc">
        <b-skeleton class="mb-2" animation="wave" width="100%" height="30px"></b-skeleton>
        <b-skeleton class="mb-2" animation="wave" width="200px"></b-skeleton>
        <b-skeleton class="mb-2" animation="wave" width="60px"></b-skeleton>
        <b-skeleton class="mb-2" animation="wave" width="80px"></b-skeleton>
        <b-skeleton class="mb-2" animation="wave" width="120px" height="30px"></b-skeleton>
      </div>
      <div class="ta-lot-list-item-buttons">
        <b-skeleton class="rounded-circle" animation="wave" width="30px" height="30px"></b-skeleton>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "LotListItemSkelleton",
  mixins: [],
};
</script>

<style lang="scss">
</style>
